import { get, post, put } from "../utils/request";

/* 存储请求地址*/
export const requestUrl = {
  getTreeData: "/xxy/trace/tree",
  getTreeNodeDetail: "/xxy/trace/leaf0",
  getHistoryByWork: "/xxy/trace/history",
  getInspectByWork: "/xxy/trace/inspection",
  getDeviceByWrk: "/xxy/trace/device",

  getSearchData: "/xxy/trace/init"
};

/* 测试接口的数据 */
export async function getRequest(url, data, options) {
  return await get(url, data, options);
}

/* 测试接口的数据 */
export async function postRequest(url, data, options) {
  return await post(url, data, options);
}
/* 测试接口的数据 */
export async function putRequest(url, data, options) {
  return await put(url, data, options);
}
